var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tour',{attrs:{"name":"chatTour","steps":_vm.chatTourSteps,"callbacks":_vm.tourCallbacks}})}
var staticRenderFns = []

export { render, staticRenderFns }